<bit-icon [name]="vaultFab()" class="tw-text-2xl" fixedWidth />
